module.exports = __webpack_public_path__ + "static/media/edsider1.187537f2.svg";